export const baseConsole = console;
const DEFAULT_LOG_LEVEL = "dir";
const logLevelMap = {
    error: 0,
    warn: 1,
    log: 2,
    debug: 3,
    info: 4,
    dir: 5,
};
export const isAboveLogLevel = (level) => {
    const logLevelValue = logLevelMap[process.env.LOG_LEVEL] ?? logLevelMap[DEFAULT_LOG_LEVEL];
    return logLevelMap[level] <= logLevelValue;
};
export const getConsoleFn = (method) => (...params) => {
    if (!isAboveLogLevel(method))
        return;
    return baseConsole[method](...params);
};
//# sourceMappingURL=consoleWrapper.js.map